import { render, staticRenderFns } from "./WysiwygViewer.vue?vue&type=template&id=f9d883c6&scoped=true&"
import script from "./WysiwygViewer.vue?vue&type=script&lang=ts&"
export * from "./WysiwygViewer.vue?vue&type=script&lang=ts&"
import style0 from "./WysiwygViewer.vue?vue&type=style&index=0&id=f9d883c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d883c6",
  null
  
)

export default component.exports